/** https://gist.github.com/homerjam/933336f19ff1302e7a8dd2c6784dd172 */

import { Plugin } from '@nuxt/types';
import { applyCacheInterceptors, applyCustomHeadersInterceptors } from 'wklr-backend-sdk/interceptors';

export default <Plugin>(({ app: { $axios } }) => {
  applyCacheInterceptors($axios);
  applyCustomHeadersInterceptors($axios);
});
